var _rect, _rect2, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollectEaze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 16.5,
    fill: "#F5F5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 16.5,
    stroke: "#FF6843"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_4362_124710)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.70514 17.1959L7 19.0345L9.31633 17.8829C13.1466 15.9786 17.587 15.7151 21.6156 17.1531L23.6216 17.8691L24.9029 15.4928L21.9308 14.84C17.705 13.9117 13.2834 14.7637 9.70514 17.1959Z",
    fill: "#FF4619"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8145 16.6143C12.783 16.9017 12.7666 17.197 12.7666 17.5C12.7666 18.5546 12.957 19.5074 13.3379 20.3574C13.734 21.223 14.2981 21.9075 15.0293 22.4111C15.7758 22.9148 16.6518 23.1669 17.6572 23.167C18.5257 23.167 19.2656 22.986 19.875 22.624C20.4792 22.289 20.9459 21.8565 21.2793 21.3301L24.0537 22.5557C23.5052 23.5457 22.6846 24.3642 21.5889 25.0088C20.5072 25.6698 19.1814 25.9999 17.6123 26C15.9668 26 14.5415 25.6217 13.3379 24.8662C12.1498 24.1265 11.2355 23.1117 10.5957 21.8213C10.0111 20.6133 9.7191 19.3245 9.68164 17.8545L10.8379 17.293L12.8496 16.3311L12.8506 16.3291L12.8145 16.6143ZM17.6123 9C19.1814 9.00005 20.5072 9.32249 21.5889 9.96777C22.6859 10.6289 23.5081 11.4479 24.0566 12.4238C24.5862 13.3554 24.9007 14.2938 25 15.2393L21.7227 14.5684C21.6195 14.2825 21.4835 14.0005 21.3145 13.7227C20.9793 13.1718 20.4996 12.7145 19.875 12.3525C19.2656 12.0063 18.5257 11.833 17.6572 11.833C16.6518 11.8331 15.7758 12.0853 15.0293 12.5889C14.3382 13.0649 13.798 13.6962 13.4062 14.4814L11.5703 15.6895L9.66992 17.0137C9.72763 15.6152 10.0354 14.3365 10.5957 13.1787C11.2356 11.8882 12.1496 10.8648 13.3379 10.1094C14.5415 9.36959 15.9668 9.00002 17.6123 9Z",
    fill: "#131313"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_4362_124710",
    x: 7,
    y: 14.4736,
    width: 17.9023,
    height: 4.56055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.62963
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.951667 0 0 0 0 0.186196 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4362_124710"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectEaze);
export default __webpack_public_path__ + "static/media/CollectEaze.290edc8b5718ad3a5c5a3cf396a04eba.svg";
export { ForwardRef as ReactComponent };